import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { getEraLabel } from '../consts';

export type VocabularyKind =
  | 'era'
  | 'findType'
  | 'material'
  | 'objectType'
  | 'siteType';

function capitalize(value: string): string {
  if (!value) {
    return value;
  }

  return value[0].toLocaleUpperCase() + value.slice(1);
}

function getDefaultLabel(kind: VocabularyKind, value: string): string {
  if (kind === 'era') {
    return getEraLabel(value);
  }

  return capitalize(value);
}

export function useVocabulary() {
  const intl = useIntl();

  return useCallback(
    (kind: VocabularyKind, value?: string | null): string => {
      if (!value) {
        return '';
      }

      const normalizedValue = value.toLocaleLowerCase();

      return intl.formatMessage({
        id: `vocabulary.${kind}.${normalizedValue}`,
        defaultMessage: getDefaultLabel(kind, value),
      });
    },
    [intl]
  );
}
